// Hook para manejar la búsqueda de productos en OrderForm
import { useState, useCallback } from 'react';
import axiosInstance from '../api/axiosInstance';

export const useProductSearch = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState<any[]>([]);
  const [isSearching, setIsSearching] = useState(false);
  const [showResults, setShowResults] = useState(false);

  const handleSearch = useCallback(async (term: string) => {
    if (term.length >= 4) {
      setIsSearching(true);
      try {
        const token = localStorage.getItem('accessToken');
        const response = await axiosInstance.get(
          `/products?search=${encodeURIComponent(term)}&limit=10&page=1&skipOfima=false&includeInactive=true`,
          {
            headers: { Authorization: `Bearer ${token}` }
          }
        )
        const products = response.data?.data || [];
        setSearchResults(Array.isArray(products) ? products : []);
      } catch (err) {
        console.error('Error buscando productos:', err);
        setSearchResults([]);
      } finally {
        setIsSearching(false);
      }
    } else {
      setSearchResults([]);
    }
  }, []);

  const handleSearchChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value.length >= 4) {
      handleSearch(value);
    } else {
      setSearchResults([]);
    }
  }, [handleSearch]);

  const clearSearch = useCallback(() => {
    setSearchTerm('');
    setShowResults(false);
  }, []);

  return {
    searchTerm,
    searchResults,
    isSearching,
    showResults,
    setShowResults,
    handleSearch,
    handleSearchChange,
    clearSearch
  };
};

